import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthStore, useDataStore } from './store'
import { hospitalesAPI, dashboardAPI } from './services/api'

// Layouts
import MainLayout from './components/layout/MainLayout'
import AuthLayout from './components/layout/AuthLayout'

// Pages
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Mapa from './pages/Mapa'
import Pacientes from './pages/Pacientes'
import Cirugias from './pages/Cirugias'
import Hospitales from './pages/Hospitales'
import Reportes from './pages/Reportes'
import Upload from './pages/Upload'
import Alertas from './pages/Alertas'
import Configuracion from './pages/Configuracion'

// Protected Route
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  
  return children
}

function App() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)
  const setHospitales = useDataStore(state => state.setHospitales)
  const setKPIs = useDataStore(state => state.setKPIs)

  // Cargar datos iniciales cuando el usuario está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      loadInitialData()
    }
  }, [isAuthenticated])

  const loadInitialData = async () => {
    try {
      const [hospitalesRes, kpisRes] = await Promise.all([
        hospitalesAPI.getAll(),
        dashboardAPI.getKPIs()
      ])
      setHospitales(hospitalesRes.data)
      setKPIs(kpisRes.data)
    } catch (error) {
      console.error('Error loading initial data:', error)
    }
  }

  return (
    <Routes>
      {/* Auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
      </Route>
      
      {/* Protected routes */}
      <Route element={
        <ProtectedRoute>
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/mapa" element={<Mapa />} />
        <Route path="/pacientes" element={<Pacientes />} />
        <Route path="/cirugias" element={<Cirugias />} />
        <Route path="/hospitales" element={<Hospitales />} />
        <Route path="/reportes" element={<Reportes />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/alertas" element={<Alertas />} />
        <Route path="/configuracion" element={<Configuracion />} />
      </Route>
      
      {/* 404 */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default App
